import React from "react"

const HouseCount = ({ number }) => (
  <div className="col order-sm-0 text-secondary text-nowrap">
    {`Viewing ${number} Homes`}
  </div>
)

export default HouseCount
